module.exports = __webpack_public_path__ + "media/flags/pl-589cf89c.svg";